import { EditorVariable } from 'components/TextEditor/TinyEditorWithVariables';

export const CLIENT_EDITOR_VARIABLES: EditorVariable[] = [
  {
    key: 'client.full_name',
    label: 'Full name',
    llm_description: 'The full name of the client',
  },
  {
    key: 'client.first_name',
    label: 'First name',
    llm_description: 'The given name of the client',
  },
  {
    key: 'client.last_name',
    label: 'Last name',
    llm_description: 'The surname or family name of the client',
  },
  {
    key: 'client.email',
    label: 'Email',
    llm_description: 'The email address of the client',
  },
  {
    key: 'client.date_of_birth',
    label: 'Date of birth',
    llm_description:
      'The birth date of the client, typically formatted as YYYY-MM-DD',
  },
  {
    key: 'client.country_citizenship',
    label: 'Country of citizenship',
    llm_description: 'The country where the client holds citizenship',
  },
  {
    key: 'client.country_residence',
    label: 'Country of residence',
    llm_description: 'The country where the client currently resides',
  },
  {
    key: 'client.mailing_address',
    label: 'Mailing address',
    llm_description: 'The complete mailing address of the client',
    isHtml: true,
  },
  {
    key: 'client.gender',
    label: 'Gender',
    llm_description: 'The gender or sex of the client',
  },
  {
    key: 'client.age',
    label: 'Age',
    llm_description: 'The age (how old) of the client',
  },
  {
    key: 'client.unique_client_identifier',
    label: 'Unique client identifier',
    llm_description:
      'A unique identifier for the client used to track their records and applications',
  },
];

export const COMPANY_EDITOR_VARIABLES: EditorVariable[] = [
  {
    key: 'company.company_name',
    label: 'Company name',
    llm_description:
      'The legal name of the company involved in the immigration process',
  },
];

export const APPLICATION_EDITOR_VARIABLES: EditorVariable[] = [
  {
    key: 'application.type',
    label: 'Application type',
    llm_description:
      'The type of application being processed for the client, such as visa or immigration application',
  },
  {
    key: 'application.supporting_documents_list',
    label: 'Supporting Documents List',
    llm_description:
      'List of supporting documents used for an immigration application, like Passport, Birth Certificate, etc.',
    isHtml: true,
  },
  {
    key: 'application.lmia_stream_type',
    label: 'LMIA stream type',
    llm_description:
      'The type of LMIA stream under which the company is applying, such as high-wage, low-wage, or agricultural stream',
  },
  {
    key: 'application.role_title',
    label: 'LMIA role title',
    llm_description:
      'The title of the job position being filled, which is relevant to the Labour Market Impact Assessment (LMIA)',
  },
];

export const LAWYER_EDITOR_VARIABLES: EditorVariable[] = [
  {
    key: 'representative.full_name',
    label: 'Representative full name',
    llm_description:
      'The full name of the immigration lawyer or authorized representative',
  },
  {
    key: 'representative.first_name',
    label: 'Representative first name',
    llm_description:
      'The given name of the immigration lawyer or authorized representative',
  },
  {
    key: 'representative.last_name',
    label: 'Representative last name',
    llm_description:
      'The surname or family name of the immigration lawyer or authorized representative',
  },
  {
    key: 'representative.email',
    label: 'Representative email',
    llm_description:
      'The email address of the immigration lawyer or authorized representative',
  },
  {
    key: 'representative.job_title',
    label: 'Representative job title',
    llm_description:
      'The job title of the immigration lawyer or authorized representative',
  },
  {
    key: 'representative.address',
    label: 'Representative address',
    llm_description:
      'The complete business address of the authorized representative',
    isHtml: true,
  },
];

export const SIGNATURE_EDITOR_VARIABLES: EditorVariable[] = [
  {
    key: 'sign.client_signature',
    label: 'Client signature',
    description:
      'E-signature block will only work with client retainer agreements',
    isHtml: true,
  },
  {
    key: 'sign.client_signed_date',
    label: 'Client signed date',
    description:
      'E-signature block will only work with client retainer agreements',
    isHtml: true,
  },
];

export const DOCUMENT_EDITOR_VARIABLES: EditorVariable[] = [
  {
    key: 'document.header',
    label: 'Document header',
    description:
      'Information will be pulled from the assigned representative (logo, address, etc)',
    llm_description:
      'The header section of a document which includes representative details like logo and address',
    isHtml: true,
  },
  {
    key: 'document.footer',
    label: 'Document footer',
    description:
      'Information will be pulled from the assigned representative (name, signature, etc)',
    llm_description:
      'The footer section of a document containing representative details such as name and signature',
    isHtml: true,
  },
  {
    key: 'document.todays_date_yyyy_mm_dd',
    label: "Today's date (YYYY-MM-DD)",
    llm_description: 'The current date in the format of year-month-day',
  },
  {
    key: 'document.current_year',
    label: 'Current year',
    llm_description: 'The current calendar year',
  },
  {
    key: 'document.current_month',
    label: 'Current month',
    llm_description: 'The current month of the year',
  },
  {
    key: 'document.current_day',
    label: 'Current day',
    llm_description: 'The current day of the month',
  },
];

export const COPILOT_PRICE_DETAILS_CHAT = [
  '250 messages per user per month',
  'Trained on Immigration, Refugees and Citizenship Canada (IRCC) laws, regulations and operational manuals',
  'Trained on the most popular Provincial Nominee Programs (BC, Alberta, Manitoba, Saskatchewan, Ontario - with more coming soon!)',
  'Draft or summarize documents, research the toughest immigration questions, write emails and more!',
  'Kept up-to-date with the most recent immigration content and programs',
  'Algorithm is constantly improving with feedback from regulated professionals',
];

export const COPILOT_PRICE_DETAILS_DRAFT = [
  'Everything in the Chat plan plus...',
  'Draft custom documents with the Visto Copilot AI in seconds',
  'Send retainers for e-signature to clients',
  'Drag and drop client variables into documents for easy customization',
  'Manage basic client information and documents in one place',
];
